import styled from 'styled-components';
import {BRANDING_PAGE_WIDTH} from '../BrandingPage.css';
import {dFlexCenter} from '../../../globalVariables/GlobalFlex';

export const wrapper=styled.div`
    width: ${BRANDING_PAGE_WIDTH};
    max-width: 100%;
    .ql-editor {
        margin-top: 50px;
    }
`;

export const top=styled.div`
    display: flex;
    height: max-content;
    padding-bottom: 40px;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
`;

export const trialButton=styled.div`
    ${dFlexCenter}
`;
